import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  "data-testid": "step-currency",
  class: "container"
}
const _hoisted_2 = { class: "container__standard-header" }
const _hoisted_3 = {
  key: 0,
  class: "t-center t-bold container__subheader"
}
const _hoisted_4 = {
  key: 1,
  class: "t-center t-bold container__subheader"
}
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = { class: "row custom-select-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_SubmitButton = _resolveComponent("SubmitButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.stepCurrencyHeader`)), 1),
    (_ctx.isStocksAccountType)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.accountInfoStocks`)), 1))
      : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.accountInfo`)), 1)),
    _createElementVNode("form", {
      onSubmit: _withModifiers(($event: any) => (null), ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Select, {
          name: "currencyChoice",
          "item-list": _ctx.currencies,
          label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.currency`),
          placeholder: 
                        _ctx.$t(`${_ctx.TRANSLATION_KEY}.chooseCurrencyPlaceholder`)
                    ,
          "cy-data": "currency",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.formData.currencyChoice = $event))
        }, null, 8, ["item-list", "label", "placeholder"])
      ]),
      _createVNode(_component_SubmitButton, {
        action: _ctx.Action.CURRENCY,
        "button-value": _ctx.$t(`${_ctx.TRANSLATION_KEY}.next`),
        "data-testid": "btn-currency-nextStep",
        data: _ctx.formData,
        class: "button button--submit",
        onClick: _ctx.handleNextStep
      }, null, 8, ["action", "button-value", "data", "onClick"])
    ], 40, _hoisted_5)
  ]))
}